import type { WaffleFlagName } from "@/services/waffleFlagNames.generated";

export const WEBMCP_FLAG: WaffleFlagName = "ENDLA_ENABLE_WEBMCP";
